export default [
    {
      path: '/interview-list',
      name: 'interview-list',
      meta: { title: '', auth: true, keepAlive: true, deepth: 1 },
      component: () => import('../../views/interview/interview-list.vue')
    },
    {
      path: '/quick-interview',
      name: 'quick-interview',
      meta: { title: '', auth: true },
      component: () => import('../../views/interview/quick-interview.vue')
    },
    {
      path: '/quick-interview-user',
      name: 'quick-interview-user',
      meta: { title: '', auth: true },
      component: () => import('../../views/interview/quick-interview-user.vue')
    }
  ];